import type { Dispatch, SetStateAction, ReactNode } from "react";
import type { UseFormGetValues, UseFormSetValue } from "react-hook-form";
import type { ICampaignWizardForm } from "../../../../../../../../../shared/types/form.type";

export type LanguageListItem = { key: string; node: ReactNode };

// Формирует обработчики выбора / удаления языков для поля language_targets формы.
export function createLanguageTargetHandlers(params: {
	allKey: string;
	languagesItems: LanguageListItem[];
	getValues: UseFormGetValues<ICampaignWizardForm>;
	setValue: UseFormSetValue<ICampaignWizardForm>;
	setSelectedLanguages: Dispatch<SetStateAction<LanguageListItem[]>>;
}) {
	const { allKey, languagesItems, getValues, setValue, setSelectedLanguages } =
		params;

	// Добавляет язык в language_targets и в локальный список (псевдо-ключ «все» пропускаем).
	const onLanguageSelect = (key: string) => {
		if (key === allKey) return;
		const item = languagesItems.find((i) => i.key === key);
		if (!item) return;
		const prev = getValues("campaign_context.campaign.language_targets") ?? [];
		const nextKeys = [...prev, item.key];
		setSelectedLanguages((s) => [...s, item]);
		setValue("campaign_context.campaign.language_targets", nextKeys, {
			shouldDirty: true,
		});
	};

	// Удаляет язык из language_targets и из локального списка выбранных.
	const onLanguageRemove = (key: string) => {
		const prev = getValues("campaign_context.campaign.language_targets") ?? [];
		const nextKeys = prev.filter((k: string) => k !== key);
		setSelectedLanguages((s) => s.filter((i) => i.key !== key));
		setValue("campaign_context.campaign.language_targets", nextKeys, {
			shouldDirty: true,
		});
	};

	return { onLanguageSelect, onLanguageRemove };
}
